<div>
  <div class="modal-title">
    ESTIMADO CLIENTE
  </div>
  <div class="modal-body">
    <div class="error-info">
      Para poder realizar esta solicitud, debe tener firmado el
      <span class="highlight"
        >Convenio de Prestación de Servicios a Distancia.</span
      >
      <!--Puede realizarlo ahora de manera on line, contactarnos al
      <span class="highlight">800 222 100</span> o a
      <a href="mailto:contactovida@security.cl">contactovida@security.cl</a>.-->
    </div>
    <div class="button-row">
      <button mat-stroked-button [mat-dialog-close]="true" class="close-button">
        Cerrar
      </button>
      <button
        mat-stroked-button
        [mat-dialog-close]="true"
        (click)="onClickFirma()"
        class="firma-button"
      >
        Firmar
      </button>
    </div>
  </div>
</div>
